import type { ReactElement } from 'react';
import { useMobileAudio } from './MobileAudioContext';

/**
 * Compact bar above the tab bar when any stream is intended/live and the
 * user is not on the Audio tab.
 */
export function MobileMiniPlayer({
  onOpenAudio,
}: {
  onOpenAudio: () => void;
}): ReactElement | null {
  const { steamroom, zeroday, anyLive, anyIntended, stopAll } = useMobileAudio();

  if (!anyLive && !anyIntended) return null;

  const labels: string[] = [];
  if (steamroom && (steamroom.isPlaying || steamroom.intendedLive)) {
    labels.push(
      steamroom.status === 'live'
        ? 'FZN PRO'
        : `FZN PRO (${steamroom.status})`,
    );
  }
  if (zeroday && (zeroday.isPlaying || zeroday.intendedLive)) {
    labels.push(
      zeroday.status === 'live'
        ? 'FZN ZERODAY'
        : `FZN ZERODAY (${zeroday.status})`,
    );
  }

  return (
    <div className="sr-mobile-miniplayer" role="region" aria-label="Now playing">
      <button
        type="button"
        className="sr-mobile-miniplayer__main"
        onClick={onOpenAudio}
      >
        <span className="sr-mobile-miniplayer__dot" aria-hidden />
        <span className="sr-mobile-miniplayer__label">
          {labels.length > 0 ? labels.join(' · ') : 'Audio'}
        </span>
      </button>
      <button
        type="button"
        className="sr-mobile-miniplayer__stop"
        onClick={stopAll}
        aria-label="Stop all streams"
      >
        Stop
      </button>
    </div>
  );
}
